import React from 'react';

import {Price} from 'components/price/price';

import s from './upgradeMatchPrice.scss';

export type PropsType = {
    price: number;
    oldPrice: number;
    match?: number | string;
};

/**
 * Match price for component Upgrade item
 * @param {PropsType} props - props component
 * @returns {Node} - element
 */
export const UpgradeMatchPrice = React.memo<PropsType>(({match, oldPrice, price}: PropsType) => (
    <p className={s.prices}>
        <span className={s.oldPrice}>
            <Price>{oldPrice}</Price>
        </span>
        &ensp;
        <span className={s.price}>
            <Price>{price}</Price>
        </span>
        &emsp;|&emsp;
        {match && <span className={s.match}>{match} Match</span>}
    </p>
));

UpgradeMatchPrice.displayName = 'UpgradeMatchPrice';
